<template>
  <div header>
    <header :class="{'h-73': !isAdmin}">
      <h1><router-link :to="`/${site}/admin`">KS 인증시스템</router-link></h1>
      <div class="nav" v-if="isAdmin">
        <div class="wrapper">
          <nav>
            <ul class="d1">
              <li>
                <router-link :to="`/${site}/admin/cert`"><span>KS인증관리</span></router-link>
                <ul class="d2">
                  <li><router-link :to="`/${site}/admin/cert/status`">KS인증현황</router-link></li>
                  <li><router-link :to="`/${site}/admin/cert/regular3y`">정기심사대상관리(3년)</router-link></li>
                  <li><router-link :to="`/${site}/admin/cert/regular1y`">1년주기공장심사대상관리</router-link></li>
                  <li><router-link :to="`/${site}/admin/cert/material`">주요자재변경관리</router-link></li>
                  <li><router-link :to="`/${site}/admin/cert/succession`">지위승계신청관리</router-link></li>
                  <li><router-link :to="`/${site}/admin/cert/cancelReturn`">인증취소/반납관리</router-link></li>
                  <li><router-link :to="`/${site}/admin/cert/disposition`">행정처분관리</router-link></li>
                  <li><router-link :to="`/${site}/admin/cert/stopResume`">생산중단/재개관리</router-link></li>
                  <li><router-link :to="`/${site}/admin/cert/unsuitable`">핵심품질부적합<br>표시정지관리</router-link></li>
                  <li><router-link :to="`/${site}/admin/cert/standardRevision`">KS표준 및<br>인증심사기준개정</router-link></li>
                  <!--<li><router-link :to="`/${site}/admin/cert/specialResearch`">특별현장조사</router-link></li>-->
                  <!--<li><router-link :to="`/${site}/admin/cert/research`">현장조사</router-link></li>-->
                </ul>
              </li>
              <li>
                <router-link :to="`/${site}/admin/progress`"><span>인증심사관리</span></router-link>
                <ul class="d2">
                  <li>
                    <router-link :to="`/${site}/admin/progress/apply`">심사신청접수관리</router-link>
                    <ul class="d3">
                      <li><router-link :to="`/${site}/admin/progress/apply/new`">인증심사</router-link></li>
                      <li><router-link :to="`/${site}/admin/progress/apply/addSpec`">인증심사(종류추가)</router-link></li>
                      <li><router-link :to="`/${site}/admin/progress/apply/addItem`">인증심사(품목추가)</router-link></li>
                      <li><router-link :to="`/${site}/admin/progress/apply/change`">인증기관변경심사</router-link></li>
<!--                      <li><router-link :to="`/${site}/admin/progress/apply/transfer`">인증기관변경 인계요청관리</router-link></li>-->
                      <li><router-link :to="`/${site}/admin/progress/apply/regular3Y`">정기심사</router-link></li>
                      <li><router-link :to="`/${site}/admin/progress/apply/regular1Y`">1년주기공장심사</router-link></li>
                      <li><router-link :to="`/${site}/admin/progress/apply/moving`">공장이전심사</router-link></li>
                      <li><router-link :to="`/${site}/admin/progress/apply/reExam`">재심사</router-link></li>
                      <li><router-link :to="`/${site}/admin/progress/apply/improve`">부적합개선조치보고</router-link></li>
                    </ul>
                  </li>
                  <li><router-link :to="`/${site}/admin/progress/prep`">심사준비관리</router-link></li>
                  <li><router-link :to="`/${site}/admin/progress/factory`">공장심사관리</router-link></li>
                  <li><router-link :to="`/${site}/admin/progress/exam`">제품심사관리</router-link></li>
                  <li><router-link :to="`/${site}/admin/progress/status`">심사현황</router-link></li>
                  <li><router-link :to="`/${site}/admin/progress/excel`">내역받기</router-link></li>
                </ul>
              </li>
              <li>
                <router-link :to="`/${site}/admin/judge`"><span>인증위원회/심사원관리</span></router-link>
                <ul class="d2">
                  <li>
                    <router-link :to="`/${site}/admin/judge/committee`">인증위원회개최현황</router-link>
                    <ul class="d3">
                      <li><router-link :to="`/${site}/admin/judge/committee/assign`">위원회심의대상현황</router-link></li>
                      <li><router-link :to="`/${site}/admin/judge/committee/process`">인증위원회개최</router-link></li>
                    </ul>
                  </li>
                  <li><router-link :to="`/${site}/admin/judge/committeeUser`">인증위원관리</router-link></li>
                  <li><router-link :to="`/${site}/admin/judge/judgeUser`">인증심사원관리</router-link></li>
                </ul>
              </li>
              <li>
                <router-link :to="`/${site}/admin/issue/process`"><span>인증서발급관리</span></router-link>
                <ul class="d2">
                  <li><router-link :to="`/${site}/admin/issue/process`">심의 후 처리</router-link></li>
                  <li><router-link :to="`/${site}/admin/issue/reissue`">인증서 재발급/변경관리</router-link></li>
                  <li><router-link :to="`/${site}/admin/issue/reissueEng`">영문인증서 발급관리</router-link></li>
                </ul>
              </li>
              <li>
                <router-link :to="`/${site}/admin/complaint`"><span>민원관리</span></router-link>
                <ul class="d2">
                  <li><router-link :to="`/${site}/admin/complaint/poor`">불량KS인증제품신고</router-link></li>
                  <li><router-link :to="`/${site}/admin/complaint/weak`">부실심사신고</router-link></li>
                  <li><router-link :to="`/${site}/admin/complaint/dissatisfaction`">업무처리 불만신고</router-link></li>
                </ul>
              </li>
              <!--<li><router-link to="/ff"><span>KS인증통계 </span></router-link></li>-->
              <!--<li>-->
                <!--<router-link to="/sales"><span>매출관리</span></router-link>-->
                <!--<ul class="d2">-->
                  <!--<li><router-link to="/">매출현황</router-link></li>-->
                  <!--<li><router-link to="/">일별매출통계</router-link></li>-->
                  <!--<li><router-link to="/">월별매출통계</router-link></li>-->
                <!--</ul>-->
              <!--</li>-->
            </ul>
            <ul class="d1">
              <li>
                <router-link :to="`/${site}/admin/site`"><span>사이트관리</span></router-link>
                <ul class="d2">
                  <li><router-link :to="`/${site}/admin/site/notice`">공지사항</router-link></li>
                  <li><router-link :to="`/${site}/admin/site/info`">정보자료실</router-link></li>
                  <li><router-link :to="`/${site}/admin/site/faq`">FAQ관리</router-link></li>
                  <li><router-link :to="`/${site}/admin/site/qna`">Q&A관리</router-link></li>
                  <!--<li><router-link :to="`/${site}/admin/site/popup`">팝업관리</router-link></li>-->
                </ul>
              </li>
              <li>
                <router-link :to="`/${site}/admin/user`"><span>회원관리</span></router-link>
                <ul class="d2">
                  <li><router-link :to="`/${site}/admin/user/company`">등록업체관리</router-link></li>
                  <li><router-link :to="`/${site}/admin/user/authorityUser`">기관회원관리</router-link></li>
                </ul>
              </li>
              <li>
                <router-link :to="`/${site}/admin/system`"><span>시스템관리</span></router-link>
                <ul class="d2">
                  <li><router-link :to="`/${site}/admin/system/standardItem`">기관인증품목관리</router-link></li>
                  <li><router-link :to="`/${site}/admin/system/factoryJudgeEvalItem`">공장심사평가항목관리</router-link></li>
                </ul>
              </li>
            </ul>
          </nav>
          <div class="util">
            <p>{{ authentication.role | charge }} <em>{{ authentication.name }}</em> {{ authentication.grade }}</p>
            <router-link :to="`/${site}/admin/userInfo`">개인정보관리</router-link>
            <a href="/logout">로그아웃</a>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>

<style lang="less">
 @import "../../../less/vars";
 @import "../../../less/asset";

  [header] { .rel; height:110px; z-index:99;
    header { .rel; background:#2f3541; .-b(#ccc); height:110px; overflow:hidden; transition:height .3s;
      h1 { .rel; .wh(1200,63); .mh-c; a { .block; .abs; .lt(0,13); .ir; .wh(162,45); .bg('@{admin}/logo.png'); .no-repeat; } }
      .nav { .rel; background:#464d5d; .-b(#2f3541); z-index:9;
        &:before { .cnt; .abs; .lt; .wh(100%,1px); background:#fff; opacity:.1; }
        nav { .rel;
          .d1 { .ib-list; }
          .d1 > li { .rel;
            > a { .block; .fs(14,2); .h(46); .tc; color:#fff; .bold; .p(0,35);
              span { .ib; .mt(9); }
              &.router-link-active { background:#2a2e38; span { .-b(@c-red,2px); } }
            }
            &:hover > a { background:#2a2e38; span { .-b(@c-red,2px); }}
            &:nth-child(5) .d2 { left:10px; width:130px; }
            &:first-child > a { .p(0,45); }
            &:nth-child(2) > a { .p(0,45); }
          }
          .d2 { .abs; .lt(15,65); .wf; .-box;
            li { .p(5,0);
              a { .fs(13); color:#555; &:hover, &.router-link-active { color:@c-red; }}
            }
          }
          .d3 { .mt(7);
            li { .p(3,0);
              a { .fs(12); color:#666; &:hover, &.router-link-active { color:#333; text-decoration: underline; }}
            }
          }
          .d1 + .d1 { .abs; .rt;
            & > li { .rel;
              > a { .p(0,20); .tc; background:#dd4250;
                &.router-link-active { span { .-b(#fff,2px); }}
              }
              &:hover > a { background:#dd4250; span { .-b(#fff,2px); }}
            }
          }
        }
      }
      .util { .abs; .rt(0,-30);
        p { .ib; color:#fff; .fs(15); .mr(20); em { color:#dd4250; }}
        a { color:#fff; .ml(10); }
      }
      &:after { .cnt; .abs; .lt(0,110px); .wf; height:412px; background:#fff; .-b(#ccc);  }
      &.on { height:522px; }
    }
  }
</style>

<script>
import $ from 'jquery';

export default {
  methods: {
    openLogin() {
      this.$store.commit('openLogin');
    },
  },
  computed: {
    isAdmin() {
      return this.isLogin && (this.authentication.role in this.values('O', 'A', 'D'));
    },
  },
  mounted() {
    $('header', this.$el).on('mouseenter', () => {
      $('header', this.$el).addClass('on');
    });

    $('header', this.$el).on('mouseleave', () => {
      $('header', this.$el).removeClass('on');
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/views/admin/common/AppHeader.vue